import { render, staticRenderFns } from "./Ganancias.vue?vue&type=template&id=44a19604&scoped=true"
import script from "./Ganancias.vue?vue&type=script&lang=js"
export * from "./Ganancias.vue?vue&type=script&lang=js"
import style0 from "./Ganancias.vue?vue&type=style&index=0&id=44a19604&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a19604",
  null
  
)

export default component.exports